<template>
  <div id="app">
    <q-layout>
      <header 
        v-if="!isApp" 
        :class="{
          'bg-white': (!isMobile && exerciseView == 'main' && position == 'exercise') || position != 'exercise',
          'bg-safeotp': position == 'exercise' && !(!isMobile && exerciseView == 'main')
        }">
        <q-toolbar v-if="!isMobile" class="q-px-none">
          <div class="logo" @click="goNext('home')">
            <img v-if="position == 'exercise' && exerciseView != 'main'" 
              class="logo_img" src="./images/logo-w.png" alt="">
            <img v-else class="logo_img" src="./assets/logo.png" alt="">
          </div>
          <q-space />
          <div v-if="position != 'etc'" class="router-link q-pa-lg" 
            :class="{'router-link-pc-active': position == 'home'}" 
            @click="goNext('home')">HOME</div>
          <div v-if="position != 'etc'" class="router-link q-pa-lg" 
            :class="{'router-link-pc-active': position == 'exercise'}"
            @click="goNext('exercise')">체험하기</div>
          <div v-if="position != 'etc'" class="router-link q-pa-lg" 
            :class="{'router-link-pc-active': position == 'help'}"
            @click="goNext('help')">도움말</div>
        </q-toolbar>
        <q-toolbar v-else>
            <div class="self-center menu_icon" @click="isActive = true">
              <img v-if="position == 'exercise'" src="./images/menu-w.png" alt="">
              <img v-else src="./images/menu.png" alt="">
            </div>
            <div class="logo self-center">
              <img v-if="position == 'exercise'" src="./images/logo-w.png" alt="">
              <img v-else src="./assets/logo.png" alt="">
            </div>    

        </q-toolbar>
      </header>
      <aside v-if="isMobile && isActive" :class="{'fade' : fadeOut}">
          <div id="mobileMenu" :class="{'fadeOut' : fadeOut}">
            <div class="flex" @click="closeMenu">
              <div class="self-center q-pa-lg">
                <q-icon name="close"/>
              </div>
            </div>
            <div class="routerBox">
              <div class="router-link q-pa-lg" 
                :class="{'router-link-mobile-active': position == 'home'}" 
                @click="goNext('home')">HOME
              </div>
              <div class="router-link q-pa-lg" 
                :class="{'router-link-mobile-active': position == 'exercise'}"
                @click="goNext('exercise')">체험하기
              </div>
              <div class="router-link q-pa-lg" 
                :class="{'router-link-mobile-active': position == 'help'}"
                @click="goNext('help')">도움말
              </div>
            </div>
         </div>
      </aside>
      <q-page-container>
        <router-view :isMobile="isMobile" :isTablet="isTablet"></router-view>
      </q-page-container>
      <footer v-if="!isApp && position == 'home'">
        <q-toolbar v-show="!isMobile" class="pc_footer">
          <div class="logo pc_footer_logo" >
            <img class= "logo_img" src="./assets/logo.png" alt="">
          </div>
          <q-space />
          <div class="router-link q-pa-lg"  
            @click="goNext('privacy')">개인정보 이용약관</div>
          <div class="router-link q-pa-lg" 
            @click="goNext('terms')">서비스 이용약관</div>
          <div class="router-link q-pa-lg" 
            @click="goNext('license')">오픈소스 라이센스</div>
        </q-toolbar>
        <div v-show="isMobile" class="mobile_footer">
          <div class=""><img class="mobile_footer_logo" src="./images/footer_logo.png" alt=""></div>
          <div class="router-link q-pa-lg"  
            @click="goNext('privacy')">개인정보 이용약관</div>
          <div class="router-link q-pa-lg" 
            @click="goNext('terms')">서비스 이용약관</div>
          <div class="router-link q-pa-lg" 
            @click="goNext('license')">오픈소스 라이센스</div>
        </div>
      </footer>
    </q-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'app',
  data () {
    return {
      isActive: false,
      window: {
        width: 0
      },
      isMobile: null,
      isTablet: null,
      fadeOut: false,
      scrollY: null
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize() 
  },
  computed: {
    ...mapState ({
      exerciseView: state => state.session.exerciseView,
      position: state => state.session.position,
      isApp: state => state.session.isApp
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
    this.handleResize()  
  },
  methods: {
    ...mapActions({ 
      saveView: 'session/save_exerciseView',
      savePosition: 'session/save_position',
      saveIsApp: 'session/save_isApp'        
    }),
    handleResize() {
      this.window.width = window.innerWidth
      this.isMobile = this.window.width < '1024' ? true : false
      this.isTablet = this.window.width >= '750' && this.window.width < '1024' ? true : false
    },
    goNext(where) {
      if(where == 'home') {
        this.$router.push("/")
        this.savePosition('home')
        this.saveView('')
        this.closeMenu()
      }
      else if(where == 'exercise') {
        this.$router.push("/exercise")
        this.savePosition('exercise')
        this.saveView('main')
        this.closeMenu()
      }
      else if(where == 'help') {
        this.$router.push('/help')
        this.savePosition('help')
        this.saveView('')
        this.closeMenu()
      } else {
        this.savePosition('etc')
        this.$router.push({ name: where + ''})
      }
    },
    closeMenu() {
      const that = this
      this.fadeOut = true
      setTimeout(function() {
        that.isActive = false
        that.fadeOut = false
      }, 500);
    }
  }
}
</script>

<style>
  /* 확인 */
  /* 미확인 */
  html {
    overflow-y: scroll;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;
  }
  html::-webkit-scrollbar {
      display: none;
  }
  .q-layout  {
    height: 100vh!important;
  }

  @import url(//fonts.googleapis.com/earlyaccess/notosanskr.css);
  @keyframes fadein {
    0% {
      opacity: 0;
      transform: translateX(-350px);
    }
    100% {
      opacity: 1;
      transform: translateX(0px);
    }
  }
  @keyframes fadeout {
    0% {
      opacity: 1;
      transform: translateX(0px);
    }
    100% {
      opacity: 0;
      transform: translateX(-350px);
    }
  }
  @keyframes movein {
    0% {
      transform: translateY(100px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
  header .logo,
  .menu_icon, 
  .router-link {
    animation: movein .7s ease;
    animation-fill-mode: forwards;
  }
  .fade {
    background: transparent!important;
  }
  
  aside {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    max-height: 100vh;
    z-index: 9998;
    background: rgb(0,0,0,0.5);
  }
  .fadeOut {
    animation: fadeout 0.7s!important;
    -moz-animation: fadeout 0.7s!important;
    -webkit-animation: fadeout 0.7s!important;
    -o-animation: fadeout 0.7s!important;
    animation-iteration-count: 1!important;
  }
  .bg-safeotp {
    background-color: rgb(48,118,255);
  }
  #mobileMenu {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 70%;
    height: 100%;
    max-height: 100vh;
    background: #fff;
    animation: fadein 0.7s;
    -moz-animation: fadein 0.7s;
    -webkit-animation: fadein 0.7s;
    -o-animation: fadein 0.7s;
    animation-iteration-count: 1;
  }
  body {
    font-family: "Noto Sans KR", sans-serif !important;
    letter-spacing: -1px;
  }
  header .logo, aside .logo, footer .logo {
    height: 40px;
  }
  header .logo img, aside .logo img, footer .logo img {
    height: 100%;
    padding: 5px 0px;
  }
  input {
    ime-mode: inactive!important;
  }

  input.q-field__native::placeholder {
    font-size: 12px!important;
    color: gray;
  }

  /* 메뉴 상단바, 또는 모바일 메뉴 */
  header .router-link {
    font-weight: bold;
  }
  header .router-link-pc-active {
    margin-bottom: -1px;
    z-index: 100;
  }

  header.bg-white .router-link {
    color: #000000;
  }
  header.bg-white .router-link-pc-active {
    color: rgb(48,118,255)!important;
    border-bottom: 3px solid rgb(48,118,255);
  }
  header.bg-white .router-link-mobile-active {
    color: rgb(48,118,255)!important;
  }

  header.bg-safeotp .router-link {
    color: lightgray;
  }
  header.bg-safeotp .router-link-pc-active {
    color: #fff!important;
    border-bottom: 3px solid #fff;
  }
  header.bg-safeotp .router-link-mobile-active {
    color: #fff!important;
  }

  #mobileMenu .router-link {
    color: black;
    font-weight: 500;
    font-size:1.2rem;
  }
  #mobileMenu .routerBox {
    margin-top: 30px;
  }
  #mobileMenu .router-link-mobile-active {
    color: rgb(48,118,255)!important;
  }


  .subTitle {
    color: #A3A3A3;
    font-size: 1.2rem;
    font-weight: 500;
  }

  .content {
    color: black;
    font-size: .8rem;
    font-weight: 600;
  }
  .q-checkbox__bg {
    border-radius: 10px!important;
    border: 1px solid;
  }
  input::placeholder {
    font-size: 1rem!important;
  }
  .q-icon {
    transform: scale(1.5);
  }
  #sendBtn :focus {
    outline: none;
  }
  #sendBtn span {
    text-decoration: none!important;
  }
  a,
  a:-webkit-any-link,
  a:-webkit-any-link:active {
    text-decoration: none;
  }
  /*  
    모바일 버전 
  */
  /* 모바일 공통 */
  @media screen and (max-width: 1023.98px) {
      /* 확인 */
    /* 미확인 */
    header {
      position: fixed!important;
      background: white;
      top: 0!important;
      z-index: 1000!important;
      width: 100%;
    }
    .q-toolbar {
      padding: 5px 0px!important;
      width: 90%!important;
    }
    .q-checkbox__inner {
      padding-top: 0px!important;
      padding-bottom: 0px!important;
    }
    input.q-field__native::placeholder, .q-checkbox__label {
      font-size: 12px!important;
      color: gray!important;
    }
    .q-field--outlined .q-field__control {
      border-radius: 10px!important;
    }
    .q-field--dense .q-field__control, .q-field--dense .q-field__marginal {
      height: 48px!important;
    }
    .mobile_footer {
      padding: 20px 0px 30px 0px;
      background-color: #181818;
      color: #5e5d5d;
      font-weight: bold;
    }
    .mobile_footer_logo {
      padding: 30px 0px 50px 30px;
      width: 140px;
    }
    .q-pa-lg {
      padding: 17px 30px!important;
    }
  }
  /* iPhone 5/SE */
  @media screen and (max-width: 320.98px) {
    .menu_icon {
      padding: 10px 20px;
    }
  }
  @media screen and (min-width: 321px) and (max-width: 599.98px) {
    .menu_icon {
      padding: 10px 20px;
    }

  }
  @media screen and (min-width: 600px) and (max-width: 768.98px) {
    .menu_icon {
      padding: 10px 30px;
    }
  }
  @media screen and (min-width: 769px) and (max-width: 1023px) {
    .logo_img {
      max-width: 140px;
      padding-left: 15px;
    }
    .menu_icon {
      padding: 10px 35px;
    }
  }
  /*  
    PC 버전 
  */
  /* PC 공통 */
  @media screen and (min-width: 1024px) {
    header {
      position: fixed!important;
      top: 0!important;
      z-index: 1000!important;
      background: white;
      width: 100%;
      padding-left: 100px;
      padding-right: 100px;
    }
    .pc_footer {
      font-weight: bold;
      margin-bottom: 10px;
    }
    .pc_footer_logo {
      padding-left: 20px;
    }
  }
  @media screen and (min-width: 1024px) and (max-width: 1439px) {
    .logo_img {
      max-width: 180px;
      padding-left: 15px;
    }
  }
  @media screen and (min-width: 1440px) and (max-width: 1999.98px) {
    header {
      padding-left: 200px!important;
      padding-right: 200px!important;
    }
  }
  @media screen and (min-width: 2000px) {
    header {
      padding-left: 300px!important;
      padding-right: 300px!important;
    }
  }

</style>
